export default function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}



// WEBPACK FOOTER //
// ./~/vue-tables-2/lib/helpers/ucfirst.js